import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SenegalFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15858'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15858)'>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='#F13642'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#17A052'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#FFF166'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 7.95663L8.6006 8.88767L9.07168 7.29559L7.73567 6.27892L9.4263 6.226L10.0001 4.66663L10.5739 6.226L12.2645 6.27892L10.9285 7.29559L11.3996 8.88767L10.0001 7.95663Z'
					fill='#17A052'
				/>
			</g>
		</svg>
	);
};

export default SenegalFlagIcon;
